// extracted by mini-css-extract-plugin
module.exports = {"labelName":"InfoLabel_labelName__3FHYp","labelValue":"InfoLabel_labelValue__31OMs"};